export const proofingWrapMeta = { wrap: true };

const proofingWrappedColumnKeys = new Set([
  "sales_text",
  "title_details",
  "frontages_text",
  "proposal",
  "notes",
  "lessee_registered",
  "lessee_trading",
]);

export function getProofingColumnMeta(columnKey) {
  return proofingWrappedColumnKeys.has(columnKey) ? proofingWrapMeta : undefined;
}
